import { BetBuilderOddStatus } from '../types/BetBuilderOdd';
import { BetBuilderPreviewSummary } from '../types/BetBuilderPreview';

export const getInactiveSelectedOddsCount = (summary: BetBuilderPreviewSummary): number => {
    return summary.legs.filter((leg) => leg.status !== BetBuilderOddStatus.Active).length;
};
